import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminCommunityPosts, adminApprovePost, adminDeletePost } from "../lib/api";
import { Toolbar, Card } from "./AdminLayout";
import { IconBtn } from "./ArticlesAdmin";
import { fmtEventDate } from "../lib/eventFormat";
import { Check, Trash2, MessageSquareQuote, Trophy } from "lucide-react";

export default function ReviewAdmin() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("pending");

  const load = () => adminCommunityPosts(filter === "all" ? "" : filter).then(setItems).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const approve = async (p) => { await adminApprovePost(p.id); toast.success("Published to Community Voices."); load(); };
  const remove = async (p) => { if (!window.confirm(`Reject and delete "${p.title}"?`)) return; await adminDeletePost(p.id); toast.success("Removed."); load(); };

  return (
    <div>
      <Toolbar title="Review Queue" subtitle="Approve contributor posts and coach game reports before they go live" />
      <div className="mb-4 flex gap-2">
        {["pending", "published", "all"].map((f) => (
          <button key={f} data-testid={`review-filter-${f}`} onClick={() => setFilter(f)} className={`rounded-full px-3 py-1.5 text-xs font-semibold capitalize ${filter === f ? "bg-[var(--navy)] text-white" : "border border-slate-300 bg-white text-slate-600"}`}>{f}</button>
        ))}
      </div>
      {items.length === 0 ? (
        <p className="font-serif-body py-16 text-center text-slate-500">Nothing here right now.</p>
      ) : (
        <div className="grid gap-4 md:grid-cols-2" data-testid="review-list">
          {items.map((p) => (
            <Card key={p.id} data-testid={`review-${p.id}`} className="overflow-hidden">
              {p.image && <img src={p.image} alt="" className="h-36 w-full object-cover" />}
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-bold uppercase text-slate-500">
                    {p.kind === "score" ? <Trophy size={10} /> : <MessageSquareQuote size={10} />} {p.kind === "score" ? "Game Report" : "Community Voice"}
                  </span>
                  <span className={`text-[11px] font-semibold ${p.status === "published" ? "text-emerald-600" : "text-amber-600"}`}>{p.status}</span>
                </div>
                <h3 className="font-display mt-2 text-lg font-bold text-[var(--navy)]">{p.title}</h3>
                {p.kind === "score" && <p className="mt-1 text-sm font-semibold text-slate-700">{p.home_team} {p.home_score} — {p.away_score} {p.away_team} <span className="text-slate-400">· {p.sport}</span></p>}
                {(p.body || []).slice(0, 2).map((para, i) => <p key={i} className="font-serif-body mt-1 text-sm text-slate-600 line-clamp-2">{para}</p>)}
                {p.standouts && <p className="mt-2 text-xs text-slate-500"><b>Standouts:</b> {p.standouts}</p>}
                <p className="mt-2 text-xs text-slate-400">By {p.author_name} · {fmtEventDate(p.created_at)}</p>
                <div className="mt-3 flex justify-end gap-2">
                  {p.status !== "published" && <IconBtn onClick={() => approve(p)} testid={`approve-post-${p.id}`}><Check size={15} className="text-emerald-600" /></IconBtn>}
                  <IconBtn onClick={() => remove(p)} danger testid={`delete-post-${p.id}`}><Trash2 size={15} /></IconBtn>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
